import dayjs from 'dayjs';

export const lastMonth = () => dayjs().subtract(1, 'M').format();

export const lastQuarter = () => dayjs().subtract(3, 'M').format();

export const lastYear = () => dayjs().subtract(1, 'y').format();
